import { render, staticRenderFns } from "./perseo_despachos_empacar.vue?vue&type=template&id=22a5c195&scoped=true"
import script from "./perseo_despachos_empacar.vue?vue&type=script&lang=js"
export * from "./perseo_despachos_empacar.vue?vue&type=script&lang=js"
import style0 from "./perseo_despachos_empacar.vue?vue&type=style&index=0&id=22a5c195&prod&scoped=true&lang=css"
import style1 from "./perseo_despachos_empacar.vue?vue&type=style&index=1&id=22a5c195&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a5c195",
  null
  
)

export default component.exports